export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.staffCategories = payload;

  return newState;
};
